// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__qwHFL","active":"MainHeader_active__nOEzl"};